<template>
  <div class="professional">
    <PageBanner :bannerObj="bannerObj"></PageBanner>
    <div class="navList">
      <div
        :class="[componentTag.key == item.key ? 'cur' : '', 'navItem']"
        v-for="item in navList"
        :key="item.key"
        @click="OnCurNav(item)"
      >
        <router-link
          class="nuxtLink"
          :to="'/professional?key=' + item.key"
          :key="item.key"
        >
          {{ item.lable }}
        </router-link>
      </div>
    </div>
    <component :is="componentTag.key" :key="componentTag.key"></component>
  </div>
</template>
<script>
import PageBanner from "../../components/common/pageBanner";
import PolicyDocument from "@/components/professional/PolicyDocument";
import ContinuingEducation from "@/components/professional/ContinuingEducation";
import StandardDocuments from "@/components/professional/StandardDocuments";
import JournalPapers from "@/components/professional/JournalPapers";
import SkillBoost from "@/components/professional/SkillBoost";
import SkillCompetition from "@/components/professional/SkillCompetition";
import SpecialOperation from "@/components/professional/SpecialOperation";
import Improvement from "@/components/professional/Improvement";
export default {
  name: "News",
  components: {
    PageBanner,
    PolicyDocument,
    ContinuingEducation,
    StandardDocuments,
    JournalPapers,
    SkillBoost,
    SkillCompetition,
    SpecialOperation,
    Improvement,
  },
  metaInfo() {
    return {
      title: "行业人才",
      meta: [
        {
          name: "keywords",
          content: "广州化工行业协会,专业技术人才,职业技能人才",
        },
        {
          name: "description",
          content:
            "广州市化工行业协会成立于1999年4月，是由广州地区从事化学工业和化工相关产业的生产、经营、储存、设计、服务咨询等企业或事业单位自愿结成的地方性、非营利性的社会组织。",
        },
      ],
    };
  },
  data() {
    return {
      componentTag: {
        lable: "政策文件",
        key: "PolicyDocument",
      },
      navList: [
        {
          lable: "政策文件",
          key: "PolicyDocument",
        },
        {
          lable: "继续教育",
          key: "ContinuingEducation",
        },
        {
          lable: "标准文件",
          key: "StandardDocuments",
        },
        {
          lable: "期刊论文",
          key: "JournalPapers",
        },
        {
          lable: "技能提升",
          key: "SkillBoost",
        },
        {
          lable: "技能竞赛",
          key: "SkillCompetition",
        },
        {
          lable: "特种作业",
          key: "SpecialOperation",
        },
        {
          lable: "专项能力提升",
          key: "Improvement",
        },
      ],

      bannerObj: {
        lableZh: "专业技术人才",
        lableEn: "professional",
        bannerImg: require("../../assets/img/professional_banner.png"),
      },
    };
  },
  created() {
    // this.getInfoManageList();
  },
  mounted() {},
  methods: {
    OnCurNav(data) {
      // console.log(data);
      this.componentTag = data;
    },
  },
  watch: {
    // 监听路由发生改变
    $route: {
      handler(newVal, oldval) {
        if (newVal != oldval && newVal.query.key) {
          let resList = this.navList.filter((item) => {
            // console.log(newVal.query.key);
            // console.log(item.key);
            return newVal.query.key === item.key;
          });
          this.componentTag = resList[0];
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
$themeColor: #003b99;
$themeMinWidth: 1180px;
.textslh {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.professional {
  width: 100%;
  min-width: $themeMinWidth;
  box-sizing: border-box;
  .banner {
    width: 100%;
  }
  .navList {
    display: flex;
    justify-content: space-between;
    width: $themeMinWidth;
    box-sizing: border-box;
    position: relative;
    z-index: 66;
    margin: -160px auto 0;
    .navItem {
      &.cur a,
      &:hover a {
        background-color: #003b99;
        color: #ffffff;
      }
      a {
        display: block;
        width: 136px;
        height: 56px;
        line-height: 56px;
        text-align: center;
        box-sizing: border-box;
        background-color: #ffffff;
        color: #333333;
        border: solid 1px #ffffff;
        font-size: 20px;
        // font-weight: bold;
        cursor: pointer;
      }
    }
  }
}
.Company {
  padding: 0 0 60px 0;
  position: relative;
}
</style>
